'use client'
import Cookies from 'js-cookie'
import { useEffect } from 'react'

import { Toaster } from '@/components/primitives/Toaster/Toaster'

export function ToastClient({ type, message }: { type: 'info' | 'error' | 'success' | 'warning'; message: string }) {
  useEffect(() => {
    // Remove the toast cookie after 5 seconds
    const timer = setTimeout(() => {
      Cookies.remove('toast', { path: '/' })
    }, 5000)

    return () => clearTimeout(timer)
  }, [])

  return <Toaster title={message} variant={type} />
}
